var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPart',{attrs:{"Item":_vm.TicketItem,"setItemForm":_vm.setItemForm,"submitData":_vm.submitData},on:{"onSuccess":_vm.onSuccess,"onFail":_vm.onFail},scopedSlots:_vm._u([{key:"default",fn:function({
        errors,
        ItemForm,
        submit
      }){return [_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-select',{attrs:{"error-messages":errors.status,"filled":true,"dense":true,"hide-details":"auto","label":"Stav","items":_vm.statuses},on:{"change":submit},model:{value:(ItemForm.status),callback:function ($$v) {_vm.$set(ItemForm, "status", $$v)},expression:"ItemForm.status"}})],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }